import React, { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { BiChevronRight } from "react-icons/bi";
import iconDashboard from "../../../assets/images/menu-icon/icon-dashboard.svg";
import iconInfo from "../../../assets/images/menu-icon/info-icon.svg";
import iconPortfolio from "../../../assets/images/menu-icon/portfolio-icon.svg";
import iconGolas from "../../../assets/images/menu-icon/goals-icon.svg";
import iconinsurance from "../../../assets/images/menu-icon/insurance.svg";
import iconAction from "../../../assets/images/menu-icon/action-icon.svg";
import iconPlaning from "../../../assets/images/menu-icon/planing-icon.svg";
import iconMisReport from "../../../assets/images/menu-icon/mis-report-icon.svg";
import iconExpenses from "../../../assets/images/menu-icon/expenses-icon.svg";
import iconPersonal from "../../../assets/images/menu-icon/personal.svg";
import iconPhysicalAssets from "../../../assets/images/menu-icon/physical-assets.svg";
import iconAccounts from "../../../assets/images/menu-icon/accounts.svg";
import iconIncome from "../../../assets/images/menu-icon/income.svg";
import iconLoans from "../../../assets/images/menu-icon/loans.svg";
import iconCompliance from "../../../assets/images/menu-icon/compliance.svg";
import iconMailManagement from "../../../assets/images/menu-icon/mail-management.svg";
import iconResearch from "../../../assets/images/menu-icon/research.svg";
import iconAdvisorActions from "../../../assets/images/menu-icon/advisor-actions.svg";
import iconAdvisory from "../../../assets/images/menu-icon/advisory.svg";
import iconAccounting from "../../../assets/images/Accounting.svg";
import iconFinancialPlaning from "../../../assets/images/Planning.svg";
import iconMaster from "../../../assets/images/Masters.svg";
import iconBd from "../../../assets/images/BD.svg";
import iconHr from "../../../assets/images/HR.svg";
import iconOperation from "../../../assets/images/Operations.svg";
import { Dispatch } from "redux";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { Disclosure } from "@headlessui/react";
import {
  ADMIN_INVOICE_TAB,
  SENT_FOR_REVIEW_TAB,
  MANAGER_TAB,
  COMPANY_MASTER_TAB,
  ADMIN_ASSIGN_TASK_TAB,
  ADVICE_LOG_BOOK,
  ADMIN_MY_TASK_TAB,
  SYSTEMATIC_PLAN_TAB,
  setDataInRedux,
  SHARE_TAB,
} from "../../../actions/CommonAction";
import WebService from "../../../utility/WebService";
import ActionTooltip from "../../ToolTip/ActionTooltip";

// const navigationClient = [
//   {
//     name: "Dashboard",
//     icon: BiBarChartAlt2,
//     href: "/dashboard",
//     img: iconDashboard,
//   },
//   {
//     name: "Information",
//     icon: GrStatusInfo,
//     img: iconInfo,
//     current: false,
//     children: [
//       {
//         name: "Personal",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Family", href: "/information/personal/family" },
//           { name: "Occupation", href: "/information/personal/occupation" },
//           {
//             name: "Health & Lifestyle",
//             href: "/information/personal/health-lifestyle",
//           },
//           { name: "Addresses", href: "/information/personal/address" },
//         ],
//       },
//       {
//         name: "Physical Assets",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Vehicles", href: "/information/physical-assets/vehicles" },
//           { name: "Household", href: "/information/physical-assets/household" },
//         ],
//       },
//       { name: "Accounts", href: "/information/accounts" },
//       { name: "Income", href: "/information/income" },
//       { name: "Loans", href: "/information/loans" },
//       // { name: "Expense Vouchers", href: "information/expense-vouchers" },
//     ],
//   },
//   {
//     name: "Portfolio",
//     icon: BsPiggyBank,
//     href: "/portfolio",
//     img: iconPortfolio,
//     removeKey: "SYSTEMATIC_PLAN_TAB",
//   },
//   { name: "Goals", icon: GrTarget, href: "/goals", img: iconGolas },
//   { name: "Expenses", icon: GrTarget, href: "/expenses", img: iconExpenses },
//   {
//     name: "Insurance",
//     icon: BsUmbrellaFill,
//     href: "/insurance",
//     img: iconinsurance,
//   },

//   {
//     name: "Actions",
//     icon: BsFileEarmarkBarGraph,
//     img: iconAction,
//     href: "",
//     current: false,
//     children: [
//       { name: "Tasks", href: "/actions" },
//       { name: "Minutes of Meeting", href: "/action/minutes-of-meeting" },
//       { name: "Raise Advice Request", href: "#" },
//     ],
//   },
//   {
//     name: "Planning",
//     img: iconPlaning,
//     icon: BsCalendar2Plus,
//     current: false,
//     children: [
//       { name: "Life insurance", href: "/planing/life-insrance-requirement" },
//       { name: "Retirement", href: "/planing/retirement" },
//     ],
//   },
//   {
//     name: "MIS Reports",
//     icon: BsFileEarmarkBarGraph,
//     img: iconMisReport,
//     href: "/reports",
//     current: false,
//     // children: [
//     //   { name: 'MF Transaction Report', href: '#' },
//     //   { name: 'Capital Gain', href: '#' },
//     //   { name: 'Transactions', href: '#' },
//     //   { name: 'Tax Calculations', href: '#' },
//     //   { name: 'Invoices', href: '#' },
//     // ],
//   },
// ];

// // Super Admin

// const navigationSuperAdmin = [
//   {
//     name: "Dashboard",
//     icon: BiBarChartAlt2,
//     href: "/dashboard",
//     img: iconDashboard,
//   },
//   {
//     name: "Masters",
//     icon: GrStatusInfo,
//     img: iconInfo,
//     current: false,
//     children: [
//       { name: "Company Details", href: "/company-master" },
//       { name: "Advisors", href: "/master/adviosr" },
//       { name: "Mail Templates", href: "/mail-template" },
//       { name: "Assumptions Master", href: "/assumption-master" },
//       { name: "Menu Organizer", href: "/master/menu-organizer" },
//       { name: "Role Managment", href: "/role-management-permission" },
//       { name: "Upload Document", href: "" },
//       {
//         name: "Advisor Goals Master",
//         icon: BsPiggyBank,
//         href: "/goalliablities/goal-liablities",
//         // img: iconDashboard,
//       },
//       {
//         name: "Help",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Help Master", href: "" },
//           { name: "Client Help Master", href: "" },
//           { name: "Financial Planning Help Master", href: "" },
//         ],
//       },
//       {
//         name: "Accounting Master",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Financial Year", href: "/accouting-master/financial-year" },
//           {
//             name: "Cost Inflation Index (CII)",
//             href: "/accouting-master/cost-Inflation",
//           },
//           { name: "GST Master", href: "/accouting-master/gst-master" },
//         ],
//       },
//       { name: "Document Master", href: "" },
//     ],
//   },
//   {
//     name: "Product Master",
//     icon: GrStatusInfo,
//     img: iconInfo,
//     current: false,
//     children: [
//       {
//         name: "Client Portfolio Master",
//         href: "product-master/client-portfolio",
//       },
//       { name: "Product Categories", href: "/information/product-categories" },
//       {
//         name: "Insurance",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Types", href: "/insurance/types" },
//           { name: "Sub Types", href: "/insurance/subTypes" },
//           { name: "Benefits Available", href: "/insurance/benifits-available" },
//           { name: "Nature of Policy", href: "/insurance/natureof-policy" },
//           { name: "Riders", href: "/insurance/riders" },
//           { name: "Categories", href: "/insurance/categories" },
//           { name: "Annuity Types", href: "/insurance/annuity-types" },
//         ],
//       },
//       { name: "Transactions Type", href: "/insurance/transactions-type" },
//       {
//         name: "Mutual Funds",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Taxation", href: "/mutualfunds/taxaction" },
//           { name: "Categories", href: "/mutualfunds/categories" },
//           { name: "Sub Categories", href: "/mutualfunds/sub-categories" },
//         ],
//       },
//       {
//         name: "Income",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Categories", href: "/income/income-categories" },
//           { name: "Heads", href: "/income/income-heads" },
//         ],
//       },
//       { name: "ULIP Funds", href: "/product-master/ulip-funds" },
//       { name: "Bonds & Debenture Types", href: "/bonds-debenture" },
//       {
//         name: "Real Estate",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Property Types", href: "/realstate/property-type" },
//           { name: "Ownership Status", href: "/realstate/ownership-status" },
//         ],
//       },
//       {
//         name: "Household",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Categories", href: "/household/household-categories" },
//           { name: "Assets", href: "/household/household-assets" },
//           // { name: "Vehicles", href: "/household/household-vehicles" },
//         ],
//       },
//       {
//         name: "Bank",
//         href: "#",
//         values: [{ name: "Loan Types", href: "/bank/loan-type" }],
//       },
//       {
//         name: "Global Product Parameters",
//         href: "/product-master/global-product-parameter",
//       },
//       {
//         name: "Establishments",
//         href: "#",
//         values: [
//           {
//             name: "Establishment Types",
//             href: "/establishment/establishment-types",
//           },
//           {
//             name: "Insurance Companies",
//             href: "/establishment/insurance-companies",
//           },
//           { name: "Banks", href: "/establishment/establishment-bank" },
//           { name: "Branch", href: "/establishment/establishment-branch" },
//           // { name: "Financial Institutions", href: "/establishment/establishment-financial-institution" },
//           {
//             name: "Depository Participants",
//             href: "/establishment/establishment-depository-participants",
//           },
//           { name: "Mutual Fund AMCs", href: "/establishment/mutual-fund" },
//         ],
//       },
//       {
//         name: "Product Parameters",
//         href: "#",
//         values: [
//           // { name: "Fixed Return And Retirement Products", href: "" },
//           {
//             name: "Insurance Products",
//             href: "/product-parameter/insurance-product",
//           },
//           { name: "Mutual Funds", href: "/product-parameter/mutual-funds" },
//           { name: "Shares", href: "product-parameter/shares" },
//         ],
//       },
//     ],
//   },
//   {
//     name: "HR",
//     icon: BsFileEarmarkBarGraph,
//     img: iconMisReport,
//     href: "",
//     current: false,
//     children: [{ name: "Employee", href: "/admin/employees" }],
//   },
//   {
//     name: "Operations",
//     icon: GrStatusInfo,
//     img: iconInfo,
//     current: false,
//     children: [
//       {
//         name: "MF Transactions Errors",
//         href: "/operations/mftransactionsErrors/mftransactions-mising-schemes",
//       },
//       {
//         name: "Shares Transactions Errors",
//         href: "/operations/shareTransaction/sharetransaction-error",
//       },
//       // { name: "Bulk NAV Import", href: "" },
//       // { name: "Bulk Share Price Import", href: "" },
//     ],
//   },
//   {
//     name: "MIS Reports",
//     icon: BsFileEarmarkBarGraph,
//     img: iconMisReport,
//     href: "",
//     current: false,
//     children: [
//       { name: "Advisor's Client", href: "/mis-report/Advisor-aua" },
//       // { name: 'Opening & Closing Prices', href: '#' },
//     ],
//   },
// ];

// //  Admin

// const navigationAdmin = [
//   {
//     name: "Dashboard",
//     icon: BiBarChartAlt2,
//     href: "/dashboard",
//     img: iconDashboard,
//   },
//   {
//     name: "Accounting",
//     icon: GrStatusInfo,
//     img: iconAccounting,
//     current: false,
//     children: [
//       { name: "Expenses Vouchers", href: "/accouting/expense-voucher" },
//       { name: "Vendor/Suppliers", href: "/vendorsupplier/vendor-supplier" },
//       { name: "AUA Calculation", href: "/accounting/aua-calculation" },
//       { name: "Client Invoice Address", href: "/accounting/client-address" },
//       {
//         name: "Invoice",
//         href: "/accounting/invoice",
//         removeKey: "ADMIN_INVOICE_TAB",
//       },
//       {
//         name: "Company Bank Accounts",
//         href: "/accounting/company-bank-account",
//       },
//     ],
//   },
//   {
//     name: "Actions",
//     icon: BsFileEarmarkBarGraph,
//     img: iconAction,
//     href: "",
//     current: false,
//     children: [
//       { name: "Tasks", href: "/actions", removeKey: "ADMIN_ASSIGN_TASK_TAB" },
//       {
//         name: "Minutes of Meeting",
//         href: "/action/minutes-of-meeting",
//         removeKey: "SENT_FOR_REVIEW_TAB",
//       },
//       { name: "Document Tracker", href: "/actions/document-tracker" },
//     ],
//   },
//   {
//     name: "MIS Reports",
//     icon: BsFileEarmarkBarGraph,
//     img: iconMisReport,
//     href: "/mis-report",
//     removeKey: "ADVICE_LOG_BOOK",

//   },
//   {
//     name: "Financial Planning",
//     icon: BsFileEarmarkBarGraph,
//     img: iconFinancialPlaning,
//     href: "",
//     current: false,
//     children: [
//       { name: "Financial Plans", href: "/financial-plans" },
//       { name: "Tax Plans", href: "#" },
//       {
//         name: "Client Portfolios",
//         href: "/financial-planing/client-portfolio",
//       },
//       { name: "Advice Request", href: "#" },
//       { name: "Proactive Advices", href: "#" },
//     ],
//   },
//   {
//     name: "Masters",
//     icon: BsFileEarmarkBarGraph,
//     img: iconMaster,
//     href: "",
//     current: false,
//     children: [
//       {
//         name: "Company Details",
//         href: "/master/master-company-master",
//         removeKey: "COMPANY_MASTER_TAB",
//       },
//       { name: "Mail Templates", href: "/master/mail-template" },
//       { name: "Advisor Goals", href: "/advisor-goals" },
//       { name: "Clients", href: "/clients" },
//       { name: "Fee Slab Master", href: "/slabs" },
//       {
//         name: "Planning Master",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Assumptions", href: "/master/planning-assumption" },
//           {
//             name: "Model Portfolios",
//             href: "/master/planning-model-portfolio",
//           },
//           { name: "Comments", href: "/master/planning-comments" },
//           {
//             name: "Disclaimer And Disclosure ",
//             href: "/master/planning-disclaimer-discloser",
//           },
//           {
//             name: "Company Sign OFF Details ",
//             href: "/master/planning-sign-off-details",
//           },
//         ],
//       },
//       { name: "Mail Groups", href: "/master/planning-mailing-group" },
//       { name: "Announcements", href: "/master/announcements" },
//       {
//         name: "Recommendations",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           {
//             name: "Insurance Products ",
//             href: "/master/insurance-product-recommendation",
//           },
//           {
//             name: "Investment Products ",
//             href: "/master/recommendation-investment-product",
//           },
//         ],
//       },
//       { name: "Global Parameter", href: "/master/global-parameter" },
//     ],
//   },
//   {
//     name: "BD",
//     icon: GrStatusInfo,
//     img: iconBd,
//     current: false,
//     children: [{ name: "AUA Selection", href: "/admin/aua-selection" }],
//   },
//   {
//     name: "HR",
//     icon: GrStatusInfo,
//     img: iconHr,
//     current: false,
//     children: [{ name: "Employees", href: "/admin/employees" }],
//   },
//   {
//     name: "Operations",
//     icon: GrStatusInfo,
//     img: iconOperation,
//     current: false,
//     children: [
//       { name: "Fixed Income Transactions", href: "" },
//       { name: "Shares Transactions", href: "" },
//       { name: "MF Transactions", href: "" },
//       { name: "MF Systematic Transactions", href: "" },
//       { name: "MF Units Reconcliation", removeKey: "MF_UNITS_RECONCLIATION" },
//     ],
//   },
// ];

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

// Icon key for each menu promoted out of the "Information" group.
function getPromotedIcon(name?: string) {
  const n = (name || "").toLowerCase();
  if (n.includes("personal")) return "iconPersonal";
  if (n.includes("physical")) return "iconPhysicalAssets";
  if (n.includes("account")) return "iconAccounts";
  if (n.includes("income")) return "iconIncome";
  if (n.includes("loan")) return "iconLoans";
  return undefined;
}

// function closeSideMenu() {
//   var element = document.getElementById("left_side_bar");
//   if (element != null) {
//     element.classList.add("hidden");
//   }

//   var element2 = document.getElementById("header_plus_content_container");
//   if (element2 != null) {
//     element2.classList.remove("blur-sm");
//   }
// }

export default function SpringMoneySideBar(props : any) {
  let history = useNavigate();

  const [navigation, setNavigation] = useState<any[]>([]);
  const dispatch: Dispatch<any> = useDispatch();
  const user_data = JSON.parse(localStorage.getItem("user_Detail") || "{}");

  // dispatch(setDataInRedux({ type: PAGINATION, value: null }));

  useEffect(() => {
    getLeftMenuList();
  }, []);

  const notWithRTA = () => {
    WebService.postAPI({
      action: `/v2/UnitsReconciliationReport/Count`,
      body: null,
    })
      .then((res: any) => {
        if (res.match_count || res.unmatch_count) {
          history("/admin/operation/unit-reconciliation-unmatched");
        }
        if (res.match_count == "0" || res.unmatch_count == "0") {
          history("/admin/operation/import-unit-reconciliation");
        }
      })
      .catch((e) => { });
  };

  const onRemove = (value: any) => {
    localStorage.removeItem("openTab");
    if (value == "ADMIN_INVOICE_TAB") {
      dispatch(setDataInRedux({ type: ADMIN_INVOICE_TAB, value: null }));
    }
    if (
      value == "ADMIN_ASSIGN_TASK_TAB" ||
      value == "ADMIN_MY_TASK_TAB" ||
      value == "MANAGER_TAB"
    ) {
      dispatch(setDataInRedux({ type: ADMIN_ASSIGN_TASK_TAB, value: null }));
      dispatch(setDataInRedux({ type: ADMIN_MY_TASK_TAB, value: null }));
      dispatch(setDataInRedux({ type: MANAGER_TAB, value: null }));
    }
    if (value == "SYSTEMATIC_PLAN_TAB") {
      dispatch(setDataInRedux({ type: SYSTEMATIC_PLAN_TAB, value: null }));
      dispatch(setDataInRedux({ type: SHARE_TAB, value: null }));
    }
    if (value == "ADVICE_LOG_BOOK") {
      dispatch(setDataInRedux({ type: ADVICE_LOG_BOOK, value: null }));
    }
    if (value == "SENT_FOR_REVIEW_TAB") {
      dispatch(setDataInRedux({ type: SENT_FOR_REVIEW_TAB, value: null }));
    }
    if (value == "COMPANY_MASTER_TAB") {
      dispatch(setDataInRedux({ type: COMPANY_MASTER_TAB, value: null }));
    }
    if (value == "MF_UNITS_RECONCLIATION") {
      notWithRTA();
    }
  };

  const onRemoveKey = (value: any) => {
    localStorage.removeItem("openTab");
    if (value == "SYSTEMATIC_PLAN_TAB") {
      dispatch(setDataInRedux({ type: SYSTEMATIC_PLAN_TAB, value: null }));
      dispatch(setDataInRedux({ type: SHARE_TAB, value: null }));
    }
  };

  const getImageStyle = (value: any) => {
    if (value == "iconPersonal") {
      return iconPersonal;
    }
    if (value == "iconPhysicalAssets") {
      return iconPhysicalAssets;
    }
    if (value == "iconAccounts") {
      return iconAccounts;
    }
    if (value == "iconIncome") {
      return iconIncome;
    }
    if (value == "iconLoans") {
      return iconLoans;
    }
    if (value == "iconCompliance") {
      return iconCompliance;
    }
    if (value == "iconMailManagement") {
      return iconMailManagement;
    }
    if (value == "iconResearch") {
      return iconResearch;
    }
    if (value == "iconAdvisorActions") {
      return iconAdvisorActions;
    }
    if (value == "iconAdvisory") {
      return iconAdvisory;
    }
    if (value == "iconDashboard") {
      return iconDashboard;
    }
    if (value == "iconInfo") {
      return iconInfo;
    }
    if (value == "iconPortfolio") {
      return iconPortfolio;
    }
    if (value == "iconGolas") {
      return iconGolas;
    }
    if (value == "iconExpenses") {
      return iconExpenses;
    }
    if (value == "iconinsurance") {
      return iconinsurance;
    }
    if (value == "iconAction") {
      return iconAction;
    }
    if (value == "iconPlaning") {
      return iconPlaning;
    }
    if (value == "iconMisReport") {
      return iconMisReport;
    }
    if (value == "iconAccounting") {
      return iconAccounting;
    }
    if (value == "iconFinancialPlaning") {
      return iconFinancialPlaning;
    }
    if (value == "iconBd") {
      return iconBd;
    }
    if (value == "iconHr") {
      return iconHr;
    }
    if (value == "iconOperation") {
      return iconOperation;
    }
    if (value == "iconMaster") {
      return iconMaster;
    }
    if (value == "iconInfo") {
      return iconInfo;
    }
    if (value == "iconInfo") {
      return iconInfo;
    }
  };

  const getLeftMenuList = () => {
    WebService.getAPI({
      action: `/v2/UserProfile/MenuList`,
      body: null,
    })
      .then((res: any) => {
        for (var i in res.final_menues) {
          if (res.final_menues[i].react_url == "/mis-report") {
            res.final_menues[i].children = [];
          }
          if (res.final_menues[i].react_url == "/advisory-header") {//Added on 04-Feb-2026 By Sourabh.
            res.final_menues[i].children = [];
          }
          if (res.final_menues[i].react_url == "/compliance-header") {//Added on 04-Feb-2026 By Sourabh.
            res.final_menues[i].children = [];
          }
          if (res.final_menues[i].react_url == "/operation-header") {//Added on 04-Feb-2026 By Shubhangi.
            res.final_menues[i].children = [];
          }
          if (res.final_menues[i].react_url == "/dashboard") {
            res.final_menues[i].children = [];
          }
          if (res.final_menues[i].react_url == "/reports") {
            res.final_menues[i].children = [];
          }
          if (res.final_menues[i].react_url == "/portfolio") {
            res.final_menues[i].children = [];
          }
          if (res.final_menues[i].react_url == "/mails") {
            res.final_menues[i].children = [];
          }

          if (user_data.is_person == "Admin") {
            for (var j in res.final_menues[i].children) {
              if (
                res.final_menues[i].children[j].react_url ==
                "/master/mail-template"
              ) {
                res.final_menues[i].children[j].href = "/mail-template";
              }
              if (res.final_menues[i].children[j].react_url == "/operations/bulk/scheme-verification") {
                res.final_menues[i].children[j].children = [];
              }
            }
          }

          if (user_data.is_person == "Employee") {
            for (var j in res.final_menues[i].children) {
              if (
                res.final_menues[i].children[j].react_url ==
                "/financial-plans"
              ) {
                res.final_menues[i].children[j].children = [];
              }            
            }
          }
        }

        // Flatten the "Information" group: promote its sub-menus to the top
        // level (giving each a relevant icon) and drop the Information parent.
        const infoIndex = res.final_menues.findIndex(
          (m: any) => (m.name || "").trim().toLowerCase() === "information"
        );
        if (infoIndex !== -1) {
          const infoChildren = res.final_menues[infoIndex].children || [];
          infoChildren.forEach((child: any) => {
            const iconKey = getPromotedIcon(child.name);
            if (iconKey) {
              child.icon = iconKey;
            }
          });
          res.final_menues.splice(infoIndex, 1, ...infoChildren);
        }

        // Merge "Physical Assets" items (Vehicles, Household) into "Personal",
        // then remove the Physical Assets menu.
        const personalMenu = res.final_menues.find(
          (m: any) => (m.name || "").trim().toLowerCase() === "personal"
        );
        const physicalIndex = res.final_menues.findIndex(
          (m: any) => (m.name || "").trim().toLowerCase().includes("physical")
        );
        if (personalMenu && physicalIndex !== -1) {
          const physicalChildren =
            res.final_menues[physicalIndex].children || [];
          personalMenu.children = [
            ...(personalMenu.children || []),
            ...physicalChildren,
          ];
          res.final_menues.splice(physicalIndex, 1);
        }

        // Rename "Accounts" to "Investment Accounts".
        const accountsMenu = res.final_menues.find(
          (m: any) => (m.name || "").trim().toLowerCase() === "accounts"
        );
        if (accountsMenu) {
          accountsMenu.name = "Investment Accounts";
        }

        // Assign icons to top-level menus that arrive without a mapped one.
        res.final_menues.forEach((m: any) => {
          const n = (m.name || "").trim().toLowerCase();
          if (n === "compliance") m.icon = "iconCompliance";
          else if (n.includes("mail")) m.icon = "iconMailManagement";
          else if (n === "research") m.icon = "iconResearch";
          else if (n.includes("advisor action")) m.icon = "iconAdvisorActions";
          else if (n === "advisory") m.icon = "iconAdvisory";
        });

        // console.log('res from menu list......', res)
        setNavigation(res.final_menues);
      })
      .catch((e) => { });
  };

  const [selectedCat, SetSelectedCat] = useState<string>("Dashboard");
  const [selectedSubCat, SetSelectedSubCat] = useState<string>();
  const [selectedSubChildCat, SetSelectedSubChildCat] = useState<string>();

  const handleSelectedCat = (name: string) => {
    SetSelectedCat(name);
  };

  const handleSelectedSubCat = (name: string) => {
    SetSelectedSubCat(name);
  };

  const handleSelectedSubChildCat = (name: string) => {
    SetSelectedSubChildCat(name);
  };

  const closeSideMenu = () =>{
    props.setIsSidebarVisible(false);
  }

  return (
    <>
      <div className="md:inset-y-0 md:flex md:w-[100%] md:h-[1200px] left-sidebar">
        <div className="flex flex-grow flex-col overflow-y-auto px-[16px] pt-[6px] pb-[16px] bg-[#f8f6fd] md:h-screen">
          <div className="mb-[2px] flex justify-end">
            <ActionTooltip title="Collapse sidebar" placement="bottom">
            <a
              href="javascript:void(0)"
              onClick={closeSideMenu}
              aria-label="Collapse sidebar"
              className="w-8 h-8 flex items-center justify-center rounded-lg text-[#7C7C7C] hover:bg-[#e5defb] hover:text-[#7B5AEC] transition-colors"
            >
              <svg
                width={22}
                height={22}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={1.9}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M4 5v14" />
                <path d="M20 12H8" />
                <path d="M13 7l-5 5 5 5" />
              </svg>
            </a>
            </ActionTooltip>
          </div>
          <div className=" flex flex-grow flex-col">
            <nav
              className="flex-1 space-y-1 bg-transparent left-mebu"
              aria-label="Sidebar"
            >
              {navigation.length > 0 &&
                navigation.map((item) =>
                  !item.children || item.children.length <= 0 ? (
                    <div
                      key={item.name}
                      className=" "
                    // title={item.name}
                    >
                      <NavLink
                        to={item.href}
                        onClick={() => {
                          onRemoveKey(item.removeKey);
                          handleSelectedCat(item.name);
                          handleSelectedSubCat("");
                          handleSelectedSubChildCat("");
                          props.setIsSidebarVisible(false);
                        }}
                        // onClick={() => { localStorage.removeItem('openTab') }}
                        className={`${selectedCat === item.name ? 'bg-[#7B5AEC] text-white' : 'text-[#5b6072] hover:bg-[#e5defb] hover:text-[#7B5AEC]'} group w-full flex items-center px-3 py-2.5 text-[13px] font-medium rounded-[10px] transition-colors`}
          
                      >
                        <img
                          src={getImageStyle(item.icon)}
                          className={`mr-[10px] flex-shrink-0 h-6 w-6 menu-icon ${selectedCat === item.name ? "brightness-0 invert" : ""}`}
                        />
                        <span
                          className={`menu-name ${selectedCat === item.name ? "font-semibold" : ""
                            }`}
                        >
                          {item.name}
                        </span>
                      </NavLink>
                    </div>
                  ) : (
                    <Disclosure
                      as="div"
                      key={item.name}
                      className=""
                    // title={item.name}
                    >
                      {({ open }) => (
                        <>
                          <Disclosure.Button
                            className={`group w-full flex items-center px-3 py-2.5 text-left text-[13px] font-medium rounded-[10px] transition-colors
                          ${selectedCat === item.name ? "bg-[#7B5AEC] text-white" : "text-[#5b6072] hover:bg-[#e5defb] hover:text-[#7B5AEC]"}`}
                          >
                            <img
                              src={getImageStyle(item.icon)}
                              className={`mr-[10px] flex-shrink-0 h-6 w-6 menu-icon ${selectedCat === item.name ? "brightness-0 invert" : ""}`}
                            />

                            <span
                              className={`flex-1 menu-name ${selectedCat === item.name
                                  ? "font-semibold text-[#FFFFFF]"
                                  : ""
                                }`}
                            >
                              {item.name}
                            </span>
                            <BiChevronRight
                              size={20}
                              className={classNames(
                                open
                                  ? "text-[#7C7C7C] rotate-90"
                                  : "text-[#7C7C7C]",
                                `${selectedCat === item.name
                                  ? "text-[#ffffff]"
                                  : ""
                                } ml-3 h-5 w-5 flex-shrink-0 transform transition-colors duration-150 ease-in-out`
                              )}
                            />
                          </Disclosure.Button>

                          <Disclosure.Panel className="mt-1 mb-1.5 ml-[22px] pl-3 border-l-2 border-[#e6e8ef]">
                            <div className="bg-white rounded-xl p-1 space-y-0.5">
                            {item.children.map((subItem: any) => (
                              <React.Fragment key={subItem.name}>
                                {subItem.children &&
                                  subItem.children.length > 0 ? (
                                  <Disclosure as="div">
                                    {({ open }) => (
                                      <>
                                        <Disclosure.Button
                                          className={`group w-full flex items-center rounded-lg pl-5 pr-2.5 py-2 text-left text-[13px]
                                        ${selectedSubCat === subItem.name
                                              ? "bg-[#e5defb] text-[#7B5AEC] font-semibold"
                                              : "text-[#6a6f82] hover:bg-[#efeafc] hover:text-[#7B5AEC] font-normal"
                                            }`}
                                        >
                                          <span className="flex-1 menu-name">
                                            {subItem.name}
                                          </span>
                                          <BiChevronRight
                                            size={18}
                                            className={classNames(
                                              open
                                                ? "text-[#7B5AEC] rotate-90"
                                                : "text-[#8a90a6]",
                                              "ml-2 flex-shrink-0 transform transition-transform duration-150 ease-in-out"
                                            )}
                                          />
                                        </Disclosure.Button>

                                        <Disclosure.Panel className="mt-0.5 ml-4 pl-2.5 border-l-2 border-[#e6e8ef] space-y-0.5">
                                          {subItem.children.map((res: any) => (
                                            <NavLink
                                              key={res.name}
                                              to={res.href}
                                              onClick={() => {
                                                onRemove(res.removeKey);
                                                handleSelectedCat(item.name);
                                                handleSelectedSubCat(
                                                  subItem.name
                                                );
                                                handleSelectedSubChildCat(
                                                  res.name
                                                );
                                                props.setIsSidebarVisible(false);
                                              }}
                                              className={`group relative flex w-full items-center rounded-lg pl-5 pr-2.5 py-1.5 text-[12.5px]
                                              ${selectedSubChildCat === res.name
                                                  ? "bg-[#e5defb] text-[#7B5AEC] font-semibold"
                                                  : "font-normal text-[#7b8092] hover:bg-[#efeafc] hover:text-[#7B5AEC]"
                                                }`}
                                            >
                                              {selectedSubChildCat === res.name && (
                                                <span className="absolute left-1.5 top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full bg-[#7B5AEC]"></span>
                                              )}
                                              {res.name}
                                            </NavLink>
                                          ))}
                                        </Disclosure.Panel>
                                      </>
                                    )}
                                  </Disclosure>
                                ) : (
                                  <NavLink
                                    to={subItem.href}
                                    onClick={() => {
                                      onRemove(subItem.removeKey);
                                      handleSelectedCat(item.name);
                                      handleSelectedSubCat(subItem.name);
                                      handleSelectedSubChildCat("");
                                      props.setIsSidebarVisible(false);
                                    }}
                                    className={`group relative flex w-full items-center rounded-lg pl-5 pr-2.5 py-2 text-[13px]
                                    ${selectedSubCat === subItem.name
                                        ? "bg-[#e5defb] text-[#7B5AEC] font-semibold"
                                        : "text-[#6a6f82] hover:bg-[#efeafc] hover:text-[#7B5AEC] font-normal"
                                      }`}
                                  >
                                    {selectedSubCat === subItem.name && (
                                      <span className="absolute left-1.5 top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full bg-[#7B5AEC]"></span>
                                    )}
                                    {subItem.name}
                                  </NavLink>
                                )}
                              </React.Fragment>
                            ))}
                            </div>
                          </Disclosure.Panel>
                        </>
                      )}
                    </Disclosure>
                  )
                )}
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}
